import { render, staticRenderFns } from "./single-tab.vue?vue&type=template&id=0da606be&"
import script from "./single-tab.vue?vue&type=script&lang=js&"
export * from "./single-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports